export const IDENTIFICATION_MASK_FORMAT = '99999?999';
export const PASSPORT_MASK_FORMAT = '*****?******';
export const RIF_MASK_FORMAT = '999999999';
export const PHONE_MASK_FORMAT = '999-9999';
export const PHONE_AREA_CODE_MASK_FORMAT = '99999999';
export const FULL_PHONE_MASK_FORMAT = '9999999999';
export const INTERNATIONAL_FULL_PHONE_MASK_FORMAT = '999999999999';
export const BUSINESS_PHONE_MASK_FORMAT = '99-999-9999';
export const TIN_MASK_FORMAT = '99999999?99999999999';
export const MAX_CURRENCY_INPUT_DIGITS = '99999999999.99';

export const ADDRESS_TYPES = {
    D: 'Domicilio',
    E: 'Empleo',
    EI: 'Empleo Int.',
    NP: 'Negocio Propio',
    NPI: 'Negocio Propio Int.',
    I: 'Internacional',
    M: 'Email',
    FB: 'Facebook',
    IG: 'Instagram',
    TW: 'Twitter'
}

export const CIVIL_STATUS = {
    C: 'Casado',
    U: 'Concubinato',
    D: 'Divorciado',
    S: 'Soltero',
    V: 'Viudo',
}

export const CLIENT_LISTS = {
    interna: 'lista_interna',
    internacional: 'lista_internacional'
}

export const ACCOUNT_CATEGORY_ID = {
    currentAccount: "3",
    savingAccount: "4",
    exteriorAccount: "5",
}

export const CURRENCY_SYMBOLS = {
    VES: '(Bs)',
    USD: '(US$)',
    EUR: '(€)',
    COP: '(Col$)',
}

export const DUE_DILIGENCE_SPECIAL_CATEGORIES = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '13', '14', '15'];

export const MAX_FILE_SIZE = 5000000;
export const MAX_FILE_SIZE_MESSAGE = "El tamaño del archivo no puede ser mayor de 5 megabites.";
export const INVALID_FILE_FORMAT_MESSAGE = 'Formato de archivo no valido. Formatos permitidos:PNG, JPG y PDF.';

export const NAMES_VALIDATION_REGEX = /^([a-zA-Z\sÑñ]+)$/;
export const NO_SPECIAL_CHARACTERS_VALIDATION_REGEX = /^[a-zA-Z0-9.,; ]+$/;
export const SOCIAL_MEDIA_USERNAME_VALIDATION_REGEX = /^[a-zA-Z0-9._-]+$/;

export const AFFILIATE_URL = 'https://www5.bancaribe.com.ve/bcm/';
export const OFFICES_URL = 'https://www.bancaribe.com.ve/oficinas';
export const APP_STORE_URL = 'https://apps.apple.com/ve/app/mi-conexi%C3%B3n-bancaribe-digital/id1531481877';
export const PLAY_STORE_URL = 'https://play.google.com/store/search?q=bancaribe&c=apps&hl=es_419&gl=US';

export const ACCOUNT_PRODUCT_NAMES = {
  myCurrentAccount: 'Mi cuenta corriente',
  currentAccountMEDollars: 'Cuenta corriente mon. ext dolar',
  currentLevelOneAccount: 'Cuenta corriente nivel 1'
}